import React from 'react';

const Icon = ({ size = '24', fill = '#ADAFB3', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...other}>
            <path
                d="M4.75 12c0-4.026 3.16-7.25 7.008-7.25 2.534 0 4.762 1.395 5.995 3.5H16.12a.75.75 0 0 0 0 1.5H20a.75.75 0 0 0 .75-.75V5a.75.75 0 0 0-1.5 0v2.844l-.118-.211c-1.465-2.611-4.213-4.383-7.374-4.383-4.72 0-8.508 3.94-8.508 8.75 0 4.81 3.788 8.75 8.508 8.75 3.786 0 6.976-2.54 8.086-6.023a.75.75 0 0 0-1.43-.454c-.926 2.904-3.567 4.977-6.656 4.977-3.849 0-7.008-3.224-7.008-7.25Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
